import produce from 'immer'
import { assign, stubFalse } from 'lodash'

import { createSelectOptions, createTreeSelectOptions } from '../../helpers'
import { COMMON_FETCH_METADATA } from '../action-types'
import { METADATA_INITIAL_STATE } from '../initial-states'

const metadataReducer = (state = METADATA_INITIAL_STATE, action) => {
  switch (action.type) {
    case COMMON_FETCH_METADATA.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: {},
        }),
      )

    case COMMON_FETCH_METADATA.COMPLETE:
      return produce(state, nextState => {
        const {
          courseTypes,
          dishTypes,
          ingredients,
          cuisineTypes,
          awards,
          mainLocationTypes,
          additionalLocationTypes,
          diets,
          allergens,
          languages,
        } = action.payload.data

        const courseTypeOptions = createTreeSelectOptions(
          courseTypes,
          'name',
          'id',
          node => !node.isCurationEnabled,
          ['isIgnored', 'dishTypeId', 'level'],
        )

        const dishTypeOptions = createTreeSelectOptions(
          dishTypes,
          'name',
          'id',
          node => !node.isCurationEnabled,
          ['isIgnored', 'courseTypeId', 'level'],
        )

        const mainLocationTypeOptions = createSelectOptions(
          mainLocationTypes,
          'name',
          'id',
          node => !node.isCurationEnabled,
        )

        const additionalLocationTypeOptions = createSelectOptions(
          additionalLocationTypes,
          'name',
          'id',
          node => !node.isCurationEnabled,
        )

        const cuisineTypeOptions = createTreeSelectOptions(
          cuisineTypes,
          'name',
          'id',
          node => !node.isCurationEnabled,
          ['isErrorProne', 'level'],
        )

        const awardOptions = createTreeSelectOptions(
          awards,
          'name',
          'id',
          node => !node.isCurationEnabled,
          ['level'],
        )

        const ingredientOptions = createTreeSelectOptions(
          ingredients,
          'name',
          'id',
          node => !node.isCurationEnabled,
          ['level'],
        )

        const dietOptions = createSelectOptions(
          diets,
          'name',
          'id',
          node => !node.isCurationEnabled,
        )

        const allergenOptions = createSelectOptions(
          allergens,
          'name',
          'id',
          node => !node.isCurationEnabled,
        )

        const languageOptions = createSelectOptions(
          languages,
          'name',
          'id',
          stubFalse,
          ['code'],
        )

        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: {
            allergenOptions,
            dietOptions,
            languageOptions,
            cuisineTypeOptions,
            mainLocationTypeOptions,
            additionalLocationTypeOptions,
            dishTypeOptions,
            courseTypeOptions,
            ingredientOptions,
            awardOptions,
            dishTypes,
          },
        })
      })

    case COMMON_FETCH_METADATA.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error,
          data: {},
        }),
      )

    case COMMON_FETCH_METADATA.CLEANUP:
      return { ...METADATA_INITIAL_STATE }

    default:
      return state
  }
}

export default metadataReducer
